<template>
	<div class="page" :style="{height:fixedHeight+'px'}" style="position: relative;overflow-y: auto;">
		<!-- 头部 -->
		<div class="titleView">
			<el-row>
				<el-col :span="4">申请批次号: {{detailData.procure_request_no}}</el-col>
				<el-col :span="4" v-if="detailData.add_info">申请日期: {{sqDate}}</el-col>
				<el-col :span="4">期望到达日期: {{expect_time}}</el-col>
				<el-col :span="4" v-if="detailData.add_info">申请人: {{detailData.add_info.add_user_info.user_name}}
				</el-col>
				<el-col :span="4">审批状态: 未审批</el-col>
				<el-col :span="4">
					<el-button type="warning" @click="handleBackClick" size="small">返回</el-button>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="4">门店确认: {{detailData.shop_confirm !=  null?'已确认':'未确认'}}</el-col>
				<el-col :span="4">采购数量: {{detailData.procure_goods_count}}</el-col>
				<el-col :span="4">总价: {{allPrice.toFixed(2)}}</el-col>
				<el-col :span="6">备注: {{detailData.remarks == ''?'- -':detailData.remarks}}</el-col>
			</el-row>
		</div>
		<div class="scrollView" style="overflow-y: scroll;">
			<!-- 商品类 -->
			<div class="shopClass" v-if="shops.length > 0">
				<div class="comH2" @click="handleShopClick">
					<div>商品类</div>
					<i class="el-icon-caret-bottom" v-if="showShop"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showShop">
					<el-table ref="multipleTable1" :data="shops" tooltip-effect="dark" size="small">
						<el-table-column :key="1" prop="goods.title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small"
									type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="goods.brand" label="品牌" align="center" />
						<el-table-column :key="3" prop="goods.sku_value" label="规格" align="center" width="120" />
						<el-table-column :key="5" prop="goods.unit" label="单位" align="center" width="60" />
						<el-table-column :key="4" label="数量" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.count" controls-position="right" :min="1"
									:max="1000" style="width:100px" @change="handleCountChange(scope.row)"
									size="small" />
							</template>
						</el-table-column>
						<el-table-column :key="6" prop="goods.pprice" label="售价" align="center" width="80" />
						<el-table-column :key="7" label="总价" align="center" width="80">
							<template slot-scope="scope">
								<span>{{scope.row.count * scope.row.goods.pprice}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">
											{{item.shop_name}}:{{item.shop_stock}}
										</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #F5882A;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procure_goods_remark" label="备注" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.procure_goods_remark"
									v-if="scope.row.procure_goods_state == 2" placeholder="请输入备注"></el-input>
								<span
									v-else>{{scope.row.procure_goods_remark==''?'--':scope.row.procure_goods_remark}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procure_goods_state != 4 && scope.row.procure_goods_state != 2">更换
								</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procure_goods_state == 4 && scope.row.procure_goods_state != 2">重新更换
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="allNum">
						<div>共{{shopCount}}件</div>
						<div>合计：{{shopPrice.toFixed(2)}}</div>
					</div>
				</div>
			</div>
			<!-- 医疗类 -->
			<div class="shopClass" v-if="drugs.length > 0">
				<div class="comH2" @click="handleDrugClick">
					<div>医疗类</div>
					<i class="el-icon-caret-bottom" v-if="showDrug"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showDrug">
					<el-table ref="multipleTable2" :data="drugs" tooltip-effect="dark" style="overflow:initial"
						size="small">
						<el-table-column :key="1" prop="goods.title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small"
									type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="goods.brand" label="品牌" align="center" />
						<el-table-column :key="3" prop="goods.sku_value" label="规格" align="center" width="120">
							<template slot-scope="scope">
								{{scope.row.goods.sku_value == ''?'--':scope.row.goods.sku_value}}
							</template>
						</el-table-column>
						<el-table-column :key="5" prop="goods.unit" label="单位" align="center" width="60" />
						<el-table-column :key="4" prop="count" label="数量" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.count" controls-position="right" :min="1"
									:max="1000" style="width:100px" @change="handleCountChange(scope.row)"
									size="small" />
							</template>
						</el-table-column>
						<el-table-column :key="6" prop="goods.pprice" label="售价" align="center" width="80" />
						<el-table-column :key="7" label="总价" align="center" width="80">
							<template slot-scope="scope">
								<span>{{scope.row.count * scope.row.goods.pprice}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">
											{{item.shop_name}}:{{item.shop_stock}}
										</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #F5882A;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procure_goods_remark" label="备注" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.procure_goods_remark"
									v-if="scope.row.procure_goods_state == 2" placeholder="请输入备注"></el-input>
								<span
									v-else>{{scope.row.procure_goods_remark==''?'--':scope.row.procure_goods_remark}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procure_goods_state != 4 && scope.row.procure_goods_state != 2">更换
								</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procure_goods_state == 4 && scope.row.procure_goods_state != 2">重新更换
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="allNum">
						<div>共{{drugCount}}件</div>
						<div>合计：{{drugPrice.toFixed(2)}}</div>
					</div>
				</div>
			</div>
			<!-- 耗材类 -->
			<div class="shopClass" v-if="haocais.length > 0">
				<div class="comH2" @click="handleHaocaiClick">
					<div>耗材类</div>
					<i class="el-icon-caret-bottom" v-if="showHaocai"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showHaocai">
					<el-table ref="multipleTable2" :data="haocais" tooltip-effect="dark" style="overflow:initial">
						<el-table-column :key="1" prop="goods.title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small"
									type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="goods.brand" label="品牌" align="center">
							<template>
								<span>--</span>
							</template>
						</el-table-column>
						<el-table-column :key="3" prop="goods.sku_value" label="规格" align="center" width="120">
							<template>
								<span>--</span>
							</template>
						</el-table-column>
						<el-table-column :key="5" prop="goods.unit" label="单位" align="center" width="60" />
						<el-table-column :key="4" prop="count" label="数量" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.count" controls-position="right" :min="1"
									:max="1000" style="width:100px" @change="handleCountChange(scope.row)" />
							</template>
						</el-table-column>
						<el-table-column :key="6" prop="goods.pprice" label="售价" align="center" width="80" />
						<el-table-column :key="7" label="总价" align="center" width="80">
							<template slot-scope="scope">
								<span>{{scope.row.count * scope.row.goods.pprice}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">
											{{item.shop_name}}:{{item.shop_stock}}
										</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #F5882A;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procure_goods_remark" label="备注" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.procure_goods_remark"
									v-if="scope.row.procure_goods_state == 2" placeholder="请输入备注"></el-input>
								<span
									v-else>{{scope.row.procure_goods_remark==''?'--':scope.row.procure_goods_remark}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procure_goods_state != 4 && scope.row.procure_goods_state != 2">更换
								</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procure_goods_state == 4 && scope.row.procure_goods_state != 2">重新更换
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="allNum">
						<div>共{{haocaiCount}}件</div>
						<div>合计：{{haocaiPrice.toFixed(2)}}</div>
					</div>
				</div>
			</div>
			<!-- 修改记录 -->
			<div class="comH2" @click="handleUpdateClick"
				v-if="detailData.update_list && detailData.update_list.length > 0">
				<div>修改记录</div>
				<i class="el-icon-caret-bottom" v-if="showDrug"></i>
				<i class="el-icon-caret-top" v-else></i>
			</div>
			<div class="tableWarp xiugaiView" v-if="showUpadate">
				<el-row class="tableName">
					<el-col :span="12" align="center">原商品</el-col>
					<el-col :span="12" align="center">修改商品</el-col>
				</el-row>
				<el-table :data="detailData.update_list" size="small">
					<el-table-column :key="7" label="商品名称">
						<template slot-scope="scope">
							<span v-if="scope.row.procure_goods_replace == null"></span>
							<span v-else>{{scope.row.procure_goods_replace.goods.title}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="8" label="品牌">
						<template slot-scope="scope">
							<span v-if="scope.row.procure_goods_replace == null"></span>
							<span v-else>{{scope.row.procure_goods_replace.goods.brand}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="9" label="规格">
						<template slot-scope="scope">
							<span v-if="scope.row.procure_goods_replace == null"></span>
							<span v-else>{{scope.row.procure_goods_replace.goods.sku_value}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="10" label="单位">
						<template slot-scope="scope">
							<span v-if="scope.row.procure_goods_replace == null"></span>
							<span v-else>{{scope.row.procure_goods_replace.goods.in_unit}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="11" label="采购数量" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.procure_goods_replace == null"></span>
							<span v-else>{{scope.row.procure_goods_replace.count}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="12">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.state == 0" type="danger" effect="dark">已删除</el-tag>
							<el-tag v-if="scope.row.state == 2" type="success" effect="dark">已添加</el-tag>
							<el-tag v-if="scope.row.state == 4" effect="dark">已变更</el-tag>
						</template>
					</el-table-column>
					<el-table-column :key="1" label="商品名称" prop="procure_goods.goods.title" />
					<el-table-column :key="2" label="品类" prop="procure_goods.goods.sku_value">
						<template slot-scope="scope">
							<span v-if="scope.row.procure_goods.goods.goods_type == 0">商品类</span>
							<span v-if="scope.row.procure_goods.goods.goods_type == 1">医疗类</span>
							<span v-if="scope.row.procure_goods.goods.goods_type == 7">耗材类</span>
						</template>
					</el-table-column>
					<el-table-column :key="3" label="品牌" prop="procure_goods.goods.brand" />
					<el-table-column :key="4" label="规格" prop="procure_goods.goods.sku_value" />
					<el-table-column :key="5" label="单位" prop="procure_goods.goods.in_unit" />
					<el-table-column :key="6" label="采购数量" prop="procure_goods.count" align="center" />
					<el-table-column :key="13" label="删除备注" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.procure_goods.goods.goods_type == 0">{{scope.row.procure_goods.delete_remark}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!-- 底部按钮 -->
		<div class="fix_btn">
			<el-button type="warning" size="small" @click="handleAddgoodsClick">添加商品</el-button>
			<el-button type="warning" size="small" @click="handleShopconfirmClick">门店确认</el-button>
			<el-button v-if="$buttonAuthority('cangku-shenpiList-apply')" type="warning" size="small" @click="handleCheckClick(0)">同意</el-button>
			<el-button type="warning" size="small" @click="handleCheckClick(1)">驳回</el-button>
		</div>
		<el-dialog title="请输入驳回理由" :visible.sync="dialogFormVisible" width="557px">
			<el-input v-model="textValue" autocomplete="off" type="textarea" placeholder="请输入5字以上" show-word-limit
				rows="6" resize="none" />
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleBHCancelClick" size="small">取 消</el-button>
				<el-button type="warning" @click="handleBHDefineClick" size="small">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="请输入删除理由" :visible.sync="dialogRemoveVisible" width="557px">
			<el-input v-model="removeRemark" autocomplete="off" type="textarea" placeholder="请输入5字以上" show-word-limit
				rows="6" resize="none" />
			<div slot="footer" class="dialog-footer">
				<el-button @click="removeRemark = '';dialogRemoveVisible = false" size="small">取 消</el-button>
				<el-button type="warning" @click="handleDeleteQRClick" size="small">确 定</el-button>
			</div>
		</el-dialog>


		<!-- 添加商品弹框 -->
		<div v-if="dialogAddShop_state">
			<dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state"
				@submit="selectShop" :tree.sync="tree"></dialogAddShop>
		</div>

	</div>
</template>
<script>
	import {
		getDetail,
		shopconfirm,
		addgoods,
		single,
		removegoods,
		updategoods,
		replacegoods,
		getCheck
	} from '@/api/purchaseApi.js'
	import caigouFilter from '@/util/caigouFilter.js'
	import dialogAddShop from "../../../components/dialog_addShop.vue"
	export default {
		components: {
			dialogAddShop
		},
		data() {
			return {
				dialogAddShop_state: false, //添加商品
				shopList: [],
				dialogFormVisible: false,
				dialogRemoveVisible: false,
				textValue: '',
				fixedHeight: '',
				id: this.$route.query.id, //跳转订单id
				tabs: this.$route.query.tabs, //切换
				detailData: {}, //订单详情
				allPrice: 0, //商品总价
				sqDate: '', //申请时间
				expect_time: '', //期望到达时间
				shops: [], //商品类
				drugs: [], //药品类
				haocais: [], //耗材类
				showShop: true, //显示商品类
				showDrug: true, //显示药品类
				showHaocai: true, //显示耗材类
				showUpadate: true, //显示修改记录
				shopCount: 0,
				shopPrice: 0,
				drugCount: 0,
				drugPrice: 0,
				haocaiCount: 0,
				haocaiPrice: 0,
				stockVisible: false, //库存
				shopStocks: [],
				addGoodsType: false, //商品弹框状态   false是添加商品  true是更换
				old_goodsId: '', //更换前商品id
				tree: [{
					id: "602f1e89c904d9db7ccf3c03"
				}, {
					id: "602f1e88c904d9db7ccf3bec"
				}, {
					id: "6049cf035a0dfcc381f9311a"
				}],
				removeRemark: '', //删除备注
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getDetailData();
			console.log('跳转tabs', this.tabs)
		},
		methods: {
			//返回按钮
			handleBackClick() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back();
					let storage = window.sessionStorage
					storage.setItem("tabs", 1)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//添加商品
			handleAddgoodsClick() {
				this.addGoodsType = false
				this.dialogAddShop_state = true;
			},
			//展开修改记录
			handleUpdateClick() {
				this.showUpadate = !this.showUpadate
			},
			//更换按钮
			handleUpClick(row) {
				console.log(row)
				this.dialogAddShop_state = true;
				this.old_goodsId = row.procure_goods_id;
				this.addGoodsType = true
			},
			//添加商品组件选择事件
			selectShop(row) {
				console.log(row)

				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				if (row.goodsType == 1) {
					console.log('选取药品')
					if (drugs != undefined) {
						console.log(drugs)
						for (let i = 0; i < drugs.length; i++) {
							if (drugs[i].procure_goods_id == row.goodsId) {
								this.$message({
									message: '该药品已重复添加',
									type: 'warning'
								})
								return
							}
						}
						if (!this.addGoodsType) {
							console.log('添加新药品')
							let parmars = {
								id: this.id,
								procure_goods: {
									goods: {
										_id: row.goodsItem.medical_id,
										title: row.goodsItem.title,
										category_id: row.goodsItem.category_info._id,
										category_name: row.goodsItem.category_info.name,
										sku_id: '',
										sku_value: row.goodsItem.old_packinfo_info.sku_value,
										goods_type: 1,
										pprice: row.goodsItem.pprice,
										brand: row.goodsItem.brand_name,
										times: row.goodsItem.medical_ext_info.use_times,
										packing_way_id: '',
										unit: row.goodsItem.old_packinfo_info.unit
									},
									count: 1,
									procure_goods_id: '',
									procure_goods_remark: "",
									procure_goods_state: 1,
								}
							}
							console.log(parmars)
							addgoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '已添加',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						} else {
							console.log('更换药品')
							let parmars = {
								id: this.id,
								old_procure_goods_id: this.old_goodsId,
								procure_goods: {
									goods: {
										_id: row.goodsItem.medical_id,
										title: row.goodsItem.title,
										category_id: row.goodsItem.category_info._id,
										category_name: row.goodsItem.category_info.name,
										sku_id: '',
										sku_value: row.goodsItem.old_packinfo_info.sku_value,
										goods_type: 1,
										pprice: row.goodsItem.pprice,
										brand: row.goodsItem.brand_name,
										times: row.goodsItem.medical_ext_info.use_times,
										packing_way_id: '',
										unit: row.goodsItem.old_packinfo_info.unit
									},
									count: 1,
									procure_goods_id: '',
									procure_goods_remark: "",
									procure_goods_state: 1,
								}
							}
							console.log(parmars)
							replacegoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '已替换',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						}

					}
				} else if (row.goodsType == 0) {
					console.log('选取商品')
					if (shops != undefined) {
						// console.log(shops)
						for (let i = 0; i < shops.length; i++) {
							if (shops[i].procure_goods_id == row.goodsId) {
								this.$message({
									message: '该商品已重复添加',
									type: 'warning'
								})
								return
							}
						}
						if (!this.addGoodsType) {
							console.log('添加新商品')
							let parmars = {
								id: this.id,
								procure_goods: {
									goods: {
										_id: row.goodsItem.goodsId,
										title: row.goodsItem.title,
										category_id: row.goodsItem.category_info._id,
										category_name: row.goodsItem.category_info.name,
										sku_id: row.skuItem._id,
										sku_value: row.skuItem.skus_name,
										goods_type: 0,
										pprice: row.wayItem.pprice,
										brand: row.goodsItem.brand_name,
										times: 1,
										packing_way_id: row.wayItem.packing_way_id,
										unit: row.wayItem.packing_way_name
									},
									count: 1,
									procure_goods_id: '',
									procure_goods_remark: "",
									procure_goods_state: 1,
								}
							}
							console.log(parmars)
							addgoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '已添加',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						} else {
							console.log('更换商品')
							let parmars = {
								id: this.id,
								old_procure_goods_id: this.old_goodsId,
								procure_goods: {
									goods: {
										_id: row.goodsItem.goodsId,
										title: row.goodsItem.title,
										category_id: row.goodsItem.category_info._id,
										category_name: row.goodsItem.category_info.name,
										sku_id: row.skuItem._id,
										sku_value: row.skuItem.skus_name,
										goods_type: 0,
										pprice: row.wayItem.pprice,
										brand: row.goodsItem.brand_name,
										times: 1,
										packing_way_id: row.wayItem.packing_way_id,
										unit: row.wayItem.packing_way_name
									},
									count: 1,
									procure_goods_id: '',
									procure_goods_remark: "",
									procure_goods_state: 1,
								}
							}
							console.log(parmars)
							replacegoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '已替换',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						}
					}
				} else if (row.goodsType == 7) {
					console.log('选取耗材')
					if (haocais != undefined) {
						for (let i = 0; i < haocais.length; i++) {
							if (haocais[i].procure_goods_id == row.goodsId) {
								this.$message({
									message: '该耗材已重复添加',
									type: 'warning'
								})
								return
							}
						}
						if (!this.addGoodsType) {
							console.log('添加新耗材')
							let parmars = {
								id: this.id,
								procure_goods: {
									goods: {
										_id: row.goodsItem.consumablematerial_id,
										title: row.goodsItem.title,
										category_id: row.goodsItem.category_info._id,
										category_name: row.goodsItem.category_info.name,
										sku_id: '',
										sku_value: '',
										goods_type: 7,
										pprice: 0,
										brand: '',
										times: row.skuItem.use_times,
										packing_way_id: '',
										unit: row.goodsItem.packing_unit
									},
									count: 1,
									procure_goods_id: '',
									procure_goods_remark: "",
									procure_goods_state: 1,
								}
							}
							console.log(parmars)
							addgoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '已添加',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						} else {
							console.log('更换耗材')
							let parmars = {
								id: this.id,
								old_procure_goods_id: this.old_goodsId,
								procure_goods: {
									goods: {
										_id: row.goodsItem.consumablematerial_id,
										title: row.goodsItem.title,
										category_id: row.goodsItem.category_info._id,
										category_name: row.goodsItem.category_info.name,
										sku_id: '',
										sku_value: '',
										goods_type: 7,
										pprice: 0,
										brand: '',
										times: row.skuItem.use_times,
										packing_way_id: '',
										unit: row.goodsItem.packing_unit
									},
									count: 1,
									procure_goods_id: '',
									procure_goods_remark: "",
									procure_goods_state: 1,
								}
							}
							console.log(parmars)
							replacegoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '已替换',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						}
					}
				}
			},
			//修改数量
			handleCountChange(row) {
				console.log(row)
				let parmars = {
					id: this.id,
					procure_goods_id: row.procure_goods_id,
					count: row.count,
					procure_goods_remark: ''
				}
				updategoods(parmars).then(res => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '修改成功'
						})
						this.getAllData()
					}
				})
			},
			//展开商品类
			handleShopClick() {
				this.showShop = !this.showShop
			},
			//展开药品类
			handleDrugClick() {
				this.showDrug = !this.showDrug
			},
			//展开耗材类
			handleHaocaiClick() {
				this.showHaocai = !this.showHaocai
			},
			//门店确认
			handleShopconfirmClick() {
				let parmars = {
					id: this.detailData.procure_request_no
				}
				shopconfirm(parmars).then((res) => {
					console.log(res)
					if (res.code == 0) {
						console.log('0')
						this.$message({
							type: 'success',
							message: '已通知'
						})
						this.getDetailData()
					}
				})
			},
			// 删除按钮
			handleDeleteClick(row) {
				this.deleteRow = row;
				this.dialogRemoveVisible = true;
			},
			// 删除弹框确认
			handleDeleteQRClick() {
				let parmars = {
					id: this.id,
					procure_goods_ids: this.deleteRow.procure_goods_id,
					remark: this.removeRemark
				}
				removegoods(parmars).then((res) => {
					console.log(res)
					if (res.code == 0) {
						this.removeRemark = '';
						this.$message({
							type: 'success',
							message: '删除成功!'
						})
						this.dialogRemoveVisible = false;
						this.getDetailData()
					}
				})
			},
			//同意或者驳回按钮
			handleCheckClick(check) {
				console.log(check)
				if (check == 0) {
					if (!this.detailData.is_shop_confirm) {
						this.$message({
							type: 'warning',
							message: '请先点击门店确认按钮'
						})
						return
					}
					this.$confirm('是否同意此申请单?', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let parmars = {
							id: this.id,
							is_check: true,
							check_remark: ''
						}
						getCheck(parmars).then((res) => {
							if (res.code == 0) {
								console.log(res)
								this.$message({
									type: 'success',
									message: '已同意'
								})
								this.$router.go(-1)
							}
						})
					}).catch((err) => {
						console.log(err)
						this.$message({
							type: 'info',
							message: '暂未同意'
						})
					})
				} else {
					this.dialogFormVisible = true
				}
			},
			//驳回弹框取消
			handleBHCancelClick() {
				this.dialogFormVisible = false;
				this.textValue = '';
			},
			//驳回弹框确定
			handleBHDefineClick() {
				if (this.textValue.length < 5) {
					this.$message({
						type: 'warning',
						message: '请输入5字以上'
					})
					return
				}
				let parmars = {
					id: this.id,
					is_check: false,
					check_remark: this.textValue
				}
				getCheck(parmars).then((res) => {
					if (res.code == 0) {
						console.log(res)
						this.$message({
							type: 'success',
							message: '已驳回'
						})
						this.dialogFormVisible = false;
						this.textValue = '';
						this.$router.go(-1)
					}
				})
			},
			//获取详情
			getDetailData() {
				let parmars = {
					id: this.id
				}
				getDetail(parmars).then((res) => {
					if (res.code == 0) {
						console.log('商品详情', res.data)
						this.detailData = res.data;
						// let price = 0;
						let detail = res.data;
						let shopList = []; //商品列表
						let drugList = []; //药品列表
						let haocaiList = []; //耗材列表

						for (let i = 0; i < detail.procure_goods_list.length; i++) {
							let parmars = {
								goodsId: detail.procure_goods_list[i].goods._id,
								skuId: detail.procure_goods_list[i].goods._id,
								zt: i
							}
							if (detail.procure_goods_list[i].goods.goods_type == '0') {
								parmars.skuId = detail.procure_goods_list[i].goods.sku_id
							} else {
								parmars.skuId = '';
							}
							single(parmars).then((resolve) => {
								console.log(resolve)
								if (resolve.code == 0) {
									if (resolve.data == null) {
										detail.procure_goods_list[i].shop_stock = [];
									} else {
										detail.procure_goods_list[i].shop_stock = resolve.data.skuList[0]
											.shop_stock;
									}

									if (detail.procure_goods_list[i].goods.goods_type == 0 && (detail
											.procure_goods_list[i].procure_goods_state == 1 || detail
											.procure_goods_list[i].procure_goods_state == 2 || detail
											.procure_goods_list[i].procure_goods_state == 4)) {
										shopList[i] = detail.procure_goods_list[i]
									} else if (detail.procure_goods_list[i].goods.goods_type == 1 && (
											detail.procure_goods_list[i].procure_goods_state == 1 || detail
											.procure_goods_list[i].procure_goods_state == 2 || detail
											.procure_goods_list[i].procure_goods_state == 4)) {
										drugList[i] = detail.procure_goods_list[i]
									} else if (detail.procure_goods_list[i].goods.goods_type == 7 && (
											detail.procure_goods_list[i].procure_goods_state == 1 || detail
											.procure_goods_list[i].procure_goods_state == 2 || detail
											.procure_goods_list[i].procure_goods_state == 4)) {
										haocaiList[i] = detail.procure_goods_list[i]
									}

									this.sqDate = caigouFilter.timestampToTime(detail.add_info.create_time)
									this.expect_time = caigouFilter.timestampToDate(detail.expect_time)
									// console.log('1111',shopList)
									this.shops = shopList.filter(item => item);
									this.drugs = drugList.filter(item => item);
									this.haocais = haocaiList.filter(item => item);
									this.getAllData()
								}
							})
						}

					} else {
						this.$message({
							message: res.info,
							type: 'warning'
						});
					}
				})
			},
			// 获取合计
			getAllData() {
				// console.log('商品列表', this.shops)
				// console.log('药品列表', this.drugs)
				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				let shopCount = 0;
				let shopPrice = 0;
				let drugCount = 0;
				let drugPrice = 0;
				let haocaiCount = 0;
				let haocaiPrice = 0;
				if (shops.length > 0) {
					for (let i = 0; i < shops.length; i++) {
						// console.log(shops[i].count)
						shopCount = (shopCount + shops[i].count);
						shopPrice = (shopPrice + shops[i].count * shops[i].goods.pprice)
					}
					this.shopCount = shopCount;
					this.shopPrice = shopPrice;
				}
				if (drugs.length > 0) {
					for (let j = 0; j < drugs.length; j++) {
						drugCount = (drugCount + drugs[j].count);
						drugPrice = (drugPrice + drugs[j].count * drugs[j].goods.pprice)
					}
					this.drugCount = drugCount;
					this.drugPrice = drugPrice
				}
				if (haocais.length > 0) {
					for (let k = 0; k < haocais.length; k++) {
						haocaiCount = (haocaiCount + haocais[k].count);
						haocaiPrice = (haocaiPrice + haocais[k].count * haocais[k].goods.pprice)
					}
					this.haocaiCount = haocaiCount;
					this.haocaiPrice = haocaiPrice
				}
				this.allPrice = drugPrice + shopPrice + haocaiPrice;
			},
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;

		// 重复头部
		.titleView {
			width: 99%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}

		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-left: 20px;
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.scrollView {
			flex: 1;
		}

		.scrollView::-webkit-scrollbar {
			display: none;
		}

		.tableWarp {
			border-radius: 6px;
			background: #fff;
			padding: 20px 30px;

			.tableName {
				line-height: 46px;
				background: #F7F6F9;
				font-size: 18px;
				color: #2A2A2A;
				font-weight: bold;
				margin-bottom: 10px;
			}

			.allNum {
				font-size: 14px;
				background: #F5F5F5;
				height: 50px;
				display: flex;
				align-items: center;
				padding-left: 20px;

				div:nth-of-type(1) {
					margin-right: 20px;
				}
			}
		}

		.fix_btn {
			width: 100%;
			height: 72px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: flex-end;

			button {
				margin-right: 30px;
			}

			button:nth-of-type(5) {
				margin-right: 60px;
			}
		}

		.xiugaiView {
			max-height: 400px;
			overflow-y: scroll;
		}

		.xiugaiView::-webkit-scrollbar {
			display: none;
		}
	}
</style>
